const dtGenerator = require("../dt/dt-generator");
const fullcontWebSocket = require("../fullcont/fullcont-web-socket");
const dtWSHandler = require("./dt-web-socket-handler");
const fileWebsocket = require("../file/file-web-socket");

//const clockWebSocket      = require('../../applications/nurse/entity/clocknurse/clock-web-socket')

export function receiver(detail) {
  console.log("dt-web-scocket>", detail);

  switch (detail.act) {
    case "addRow":
      addRow(detail);
      break;
    case "updateRow":
      updateRow(detail);
      break;
    case "deleteRow":
      deleteRow(detail);
      break;
    case "fileUpdate":
      fileWebsocket.start(detail.row[0]);
      break;
  }
}

function addRow(detail) {
  // console.log('addRow>', detail)

  //if the dt exist,
  if (!dtExist(detail.row[0])) {
    return;
  }

  dtWSHandler.start(detail);
} /*addRow*/

//update tr, if it exist
function updateRow(detail) {
  const rowDetail = detail.row[0];

  // Lista de destinos especiales
  const specialDestinations = [
    "accountsPayable",
    "accountsReceivable",
    "customerProfit",
    "providerProfit"
  ];

  // Ejecutar control si es destino especial
  if (specialDestinations.includes(rowDetail.dest)) {
    fullcontWebSocket.control(rowDetail);
    console.log("Control executed for special destination:", rowDetail.dest);  
  }
  
  fullcontWebSocket.control(rowDetail);
  // Si la fila no existe, salir
  if (!trExist(rowDetail)) return;

  // Continuar con control y actualización del dt
  dtWSHandler.start(detail);
}



function deleteRow(detail) {
  // console.log('deleteRow >')

  //this function control if the element exist or not
  dtGenerator.deleteRow(detail.row[0]);

  fullcontWebSocket.forDeleted(detail.row[0]);
} /*deleteRow*/

//stop the update if the tr element don't exist
function trExist(elem) {
  console.log('stopUpdate>', elem)

  const elemHtml = document.getElementById(`${elem.dest}-tableRow-${elem.id}`);

  if (elemHtml === null || elemHtml === undefined) {
    return false;
  }

  return true;
}

//stop the update if the tr element don't exist
function dtExist(elem) {
  //console.log('stopUpdate>')

  const elemHtml = document.getElementById(`${elem.dest}-dt`);

  if (elemHtml === null || elemHtml === undefined) {
    return false;
  }

  return true;
}